import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from "../apiConfig";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";

const BetChallengeReport = () => {
  const [loading, setLoading]               = useState(true);
  const [data, setData]                     = useState([]);
  const [levelBreakdown, setLevelBreakdown] = useState([]);
  const [summary, setSummary]               = useState({
    totalBonusPaid: 0,
    totalClaims:    0,
    totalCount:     0,
  });
  const [pageCount, setPageCount]   = useState(1);
  const [activeRange, setActiveRange] = useState("today");
  const [startDate, setStartDate]   = useState("");
  const [endDate, setEndDate]       = useState("");
  const [userIdFilter, setUserIdFilter] = useState("");
  const currentPage = useRef(1);
  const limit = 50;

  const toLocal = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const getDateRange = (range) => {
    const now = new Date();
    const today = toLocal(now);
    if (range === "today")   return { start: today, end: today };
    if (range === "weekly")  {
      const s = new Date(now); s.setDate(now.getDate() - 7);
      return { start: toLocal(s), end: today };
    }
    if (range === "monthly") {
      const s = new Date(now.getFullYear(), now.getMonth(), 1);
      return { start: toLocal(s), end: today };
    }
    return { start: "", end: "" };
  };

  const fetchData = async (start, end, pageOnly = false, uid = userIdFilter) => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiConfig.baseURL}/api/agent/BetChallengeReport`, {
        params: {
          startDate: start || undefined,
          endDate:   end   || undefined,
          page:      currentPage.current,
          limit,
          user_id:   uid || undefined,
        },
      });

      setData(res.data.data || []);
      setPageCount(res.data.pageCount || 1);

      if (!pageOnly) {
        setSummary({
          totalBonusPaid: res.data.totalBonusPaid || 0,
          totalClaims:    res.data.totalClaims    || 0,
          totalCount:     res.data.totalCount     || 0,
        });
        setLevelBreakdown(res.data.levelBreakdown || []);
      }
    } catch (err) {
      console.error("BetChallengeReport fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const { start, end } = getDateRange("today");
    setStartDate(start);
    setEndDate(end);
    fetchData(start, end);
  }, []);

  const handleRangeClick = (range) => {
    setActiveRange(range);
    if (range === "custom") return;
    const { start, end } = getDateRange(range);
    setStartDate(start);
    setEndDate(end);
    currentPage.current = 1;
    fetchData(start, end);
  };

  const handleSearch = () => {
    currentPage.current = 1;
    fetchData(startDate, endDate, false, userIdFilter);
  };

  const handleClear = () => {
    setUserIdFilter("");
    currentPage.current = 1;
    fetchData(startDate, endDate, false, "");
  };

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    fetchData(startDate, endDate, true);
  };

  const formatDate = (iso) => {
    const d = new Date(iso);
    return `${String(d.getDate()).padStart(2,"0")}.${String(d.getMonth()+1).padStart(2,"0")}.${d.getFullYear()} ${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`;
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin: 1rem 0; display: flex; flex-direction: row; justify-content: center;
    list-style-type: none; padding: 0; gap: 4px;
    li a { border-radius: 6px; padding: 4px 10px; border: 1px solid #334155; cursor: pointer; color: #000; font-size: 13px; }
    li.active a { background: #f59e0b; border-color: #f59e0b; color: #000; font-weight: 700; }
    li.disabled a { color: #aaa; cursor: default; }
  `;

  const ranges = ["today", "weekly", "monthly", "custom"];

  return (
    <>
     <Navbar /><Chatbox /><HeaderRight /><LeftSidebar />
    <div className="content-body">
      <div className="container-fluid">
        <div className="col-lg-12">

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4 mt-3">
            <h4 className="mb-0">🏆 Bet Challenge — Claim Report</h4>
          </div>

          {/* Range Buttons */}
          <div className="mb-3 d-flex gap-2 flex-wrap">
            {ranges.map((r) => (
              <button key={r} onClick={() => handleRangeClick(r)}
                style={{
                  padding: "6px 14px", borderRadius: "20px", border: "none",
                  cursor: "pointer", fontSize: "13px", fontWeight: "600",
                  background: activeRange === r ? "#f59e0b" : "#fff",
                  color: "#000",
                }}>
                {r.charAt(0).toUpperCase() + r.slice(1)}
              </button>
            ))}
          </div>

          {/* Custom Date */}
          {activeRange === "custom" && (
            <div className="row mb-3 g-2 align-items-end">
              <div className="col-md-4">
                <input type="date" value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="form-control form-control-sm"
                  style={{ color: "black", border: "1px solid #334155" }} />
              </div>
              <div className="col-auto" style={{ color: "black" }}>→</div>
              <div className="col-md-4">
                <input type="date" value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="form-control form-control-sm"
                  style={{ color: "black", border: "1px solid #334155" }} />
              </div>
              <div className="col-md-2">
                <button onClick={() => { currentPage.current = 1; fetchData(startDate, endDate); }}
                  className="btn btn-sm w-100"
                  style={{ background: "#f59e0b", color: "#000", fontWeight: "700" }}>
                  Search
                </button>
              </div>
            </div>
          )}

          {/* User ID Filter */}
          <div className="row mb-3 g-2 align-items-end">
            <div className="col-md-4">
              <label style={{ color: "#000", fontSize: "12px", display: "block", marginBottom: "4px" }}>
                User ID (optional)
              </label>
              <input type="text" value={userIdFilter}
                onChange={(e) => setUserIdFilter(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                placeholder="e.g. U12345"
                className="form-control form-control-sm"
                style={{ color: "black", border: "1px solid #334155" }} />
            </div>
            <div className="col-md-2">
              <button onClick={handleSearch} className="btn btn-sm w-100"
                style={{ background: "#f59e0b", color: "#000", fontWeight: "700" }}>
                🔍 Search
              </button>
            </div>
            <div className="col-md-2">
              <button onClick={handleClear} className="btn btn-sm w-100"
                style={{ background: "#fff", color: "#000", border: "1px solid #334155" }}>
                ✕ Clear
              </button>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row mb-4 g-3">
            <div className="col-6 col-md-3">
              <div className="card text-center" style={{ border: "1px solid #334155", borderRadius: "12px" }}>
                <div className="card-body p-3">
                  <div style={{ color: "#000", fontSize: "12px" }}>Total Claims</div>
                  <div style={{ color: "#000", fontSize: "22px", fontWeight: "700" }}>{summary.totalClaims}</div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card text-center" style={{ border: "1px solid #16a34a", borderRadius: "12px" }}>
                <div className="card-body p-3">
                  <div style={{ color: "#000", fontSize: "12px" }}>Total Bonus Paid</div>
                  <div style={{ color: "#000", fontSize: "22px", fontWeight: "700" }}>
                    ৳{summary.totalBonusPaid?.toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card text-center" style={{ border: "1px solid #b45309", borderRadius: "12px" }}>
                <div className="card-body p-3">
                  <div style={{ color: "#000", fontSize: "12px" }}>Total Records</div>
                  <div style={{ color: "#000", fontSize: "22px", fontWeight: "700" }}>{summary.totalCount}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Level Breakdown */}
          {levelBreakdown.length > 0 && (
            <div className="card mb-4" style={{ border: "1px solid #334155" }}>
              <div className="card-body p-0">
                <div style={{ padding: "12px 16px", borderBottom: "1px solid #334155" }}>
                  <h6 className="mb-0" style={{ color: "#000" }}>📊 Per-Level Breakdown</h6>
                </div>
                <div style={{ overflowX: "auto" }}>
                  <table className="table table-hover mb-0">
                    <thead style={{ borderBottom: "2px solid #334155" }}>
                      <tr>
                        <th style={{ color: "#000", background: "white" }}>Level</th>
                        <th style={{ color: "#000", background: "white" }}>Total Claims</th>
                        <th style={{ color: "#000", background: "white" }}>Total Bonus Paid</th>
                      </tr>
                    </thead>
                    <tbody>
                      {levelBreakdown.map((l) => (
                        <tr key={l.level}>
                          <td style={{ fontWeight: "700", color: "#000" }}>Level {l.level}</td>
                          <td style={{ color: "#000" }}>{l.totalClaimCount}</td>
                          <td style={{ color: "#000", fontWeight: "700" }}>৳{l.totalBonusPaid?.toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* Main Table */}
          <div className="card" style={{ border: "1px solid #334155" }}>
            <div className="card-body p-0">
              {loading ? (
                <div className="text-center p-5" style={{ color: "#000" }}>Loading...</div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="table table-hover mb-0">
                    <thead style={{ borderBottom: "2px solid #334155" }}>
                      <tr>
                        <th style={{ color: "#000", background: "white" }}>#</th>
                        <th style={{ color: "#000", background: "white" }}>User ID</th>
                        <th style={{ color: "#000", background: "white" }}>Mobile</th>
                        <th style={{ color: "#000", background: "white" }}>Level</th>
                        <th style={{ color: "#000", background: "white" }}>Bonus</th>
                        <th style={{ color: "#000", background: "white" }}>Target</th>
                        <th style={{ color: "#000", background: "white" }}>Turnover</th>
                        <th style={{ color: "#000", background: "white" }}>Claimed At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, i) => (
                          <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                            <td style={{ color: "#000", fontSize: "13px" }}>
                              {(currentPage.current - 1) * limit + i + 1}
                            </td>
                            <td style={{ color: "#000", fontWeight: "600", fontSize: "13px" }}>
                              {item.user_id}
                            </td>
                            <td style={{ color: "#000", fontSize: "13px" }}>
                              {item.mobile || item.email || "—"}
                            </td>
                            <td>
                              <span style={{
                                background: "#f59e0b", color: "#000",
                                padding: "2px 10px", borderRadius: "10px",
                                fontWeight: "700", fontSize: "12px",
                              }}>
                                Level {item.level}
                              </span>
                            </td>
                            <td style={{ color: "#16a34a", fontWeight: "700", fontSize: "14px" }}>
                              ৳{item.bonus_amount?.toLocaleString()}
                            </td>
                            <td style={{ color: "#000", fontSize: "13px" }}>
                              ৳{item.target_amount?.toLocaleString() || "—"}
                            </td>
                            <td style={{ color: "#000", fontSize: "13px" }}>
                              ৳{item.current_turnover?.toLocaleString()}
                            </td>
                            <td style={{ color: "#000", fontSize: "13px" }}>
                              {formatDate(item.claimed_at)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center py-5" style={{ color: "#000" }}>
                            কোনো claim পাওয়া যায়নি
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          {/* Pagination */}
          <MyPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            marginPagesDisplayed={2}
            forcePage={currentPage.current - 1}
          />

        </div>
      </div>
    </div></>
  );
  
};

export default BetChallengeReport;